var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 12.871,
    viewBox: "0 0 28 12.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-university",
    "data-name": "Icon map-university",
    d: "M14.763,17.909A12.035,12.035,0,0,0,7.157,20.27v2.681H22.369V20.27A12.038,12.038,0,0,0,14.763,17.909Zm13.966-1.376-14-6.453-14,6.453L3.062,17.6v1.642c-.585.121-.587.428-.587.792a.978.978,0,0,0,.207.618l-.8,1.713H4.737l-.793-1.714a.942.942,0,0,0,.243-.589c0-.364-.539-.7-.539-.821V17.875l2.925,1.314v-.116c1.755-1.526,4.839-2.5,8.19-2.5s6.437.969,8.192,2.5v.116Z",
    transform: "translate(-0.729 -10.08)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUniversity);
export default __webpack_public_path__ + "static/media/icon-university.e7fe284c40c3f3fc7ff5bae7ac67204a.svg";
export { ForwardRef as ReactComponent };